import Drawer from "@mui/material/Drawer";
import LoadingWrapper from "components/Loading/LoadingWrapper";
import useAPI from "hooks/useAPI";
import { GlobalQueries } from "hooks/useRefreshQuery";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import Sitemap from "routes/sitemap";
import { currencyFormat } from "../../helpers/functions";
import { useTranslation } from "react-i18next";
import CartDrawerItem from "./CartDrawerItem";
import icons from "helpers/icons";
import styles from "./CartDialog.module.scss";

const CartDialog = ({ openDialog, setOpenDialog, translateKey, onOpenCategories }) => {
    const { t } = useTranslation();
    const api = useAPI();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { data, isLoading } = useQuery([GlobalQueries.Cart], () => api.list(`/cart`));
    const items = data?.items ?? [];
    const cost = data?.summary;

    const closeDialog = () => setOpenDialog(false);
    const continueShopping = () => {
        closeDialog();
        if (pathname?.includes("/korpa/potvrda")) navigate("/pocetna");
    };
    const finishShopping = () => {
        closeDialog();
        navigate(Sitemap.cart.checkout);
    };

    return (
        <Drawer anchor="right" open={openDialog} onClose={closeDialog} PaperProps={{ className: styles.drawerPaper, role: "dialog", "aria-modal": true, "aria-labelledby": "cart-drawer-title" }}>
            <div className={styles.header}>
                <div className={styles.heading}>
                    <h2 id="cart-drawer-title">{t(`${translateKey}-title`)}</h2>
                    {!isLoading && items.length > 0 && <span className={styles.itemCount}>{items.length}</span>}
                </div>
                <div className={styles.headerActions}>
                    <button type="button" className={styles.mobileCategoriesButton} onClick={onOpenCategories} aria-label="Otvori kategorije">
                        <img src={icons.catalogue} alt="" />
                        <span>Kategorije</span>
                    </button>
                    <button type="button" className={styles.closeButton} onClick={closeDialog} aria-label={t("global-default-text-Close", { defaultValue: "Zatvori" })}>
                        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                            <path d="m5 5 10 10M15 5 5 15" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>
            </div>

            <div className={styles.body}>
                <LoadingWrapper isLoading={isLoading}>
                    {items.length > 0 ? (
                        <div className={styles.items}>
                            {items.map((item) => (
                                <CartDrawerItem key={item.product.id} item={item} onNavigate={closeDialog} translateKey={translateKey} />
                            ))}
                        </div>
                    ) : (
                        <div className={styles.emptyState} role="status">
                            <span className={styles.emptyIcon} aria-hidden="true">
                                <svg viewBox="0 0 48 48" fill="none">
                                    <path d="M8 16h32l-2.5 23h-27L8 16ZM17 18v-5a7 7 0 0 1 14 0v5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                            <p>{t(`${translateKey}-text-no_content_in_cart`)}</p>
                        </div>
                    )}
                </LoadingWrapper>
            </div>

            <div className={styles.footer}>
                {items.length > 0 && (
                    <div className={styles.total}>
                        <span>{t(`${translateKey}-text-total`).replace(/:\s*$/, "")}:</span>
                        <strong>{currencyFormat(cost?.totals?.subtotal, cost?.currency)}</strong>
                    </div>
                )}
                <div className={styles.actions}>
                    <button type="button" className={styles.continue} onClick={continueShopping}>{t(`${translateKey}-button-continue`)}</button>
                    {items.length > 0 && <button type="button" className={styles.checkout} onClick={finishShopping}>{t(`${translateKey}-button-finish`)}</button>}
                </div>
            </div>
        </Drawer>
    );
};

export default CartDialog;
